
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import styles from 'styles/news.module.css';
import classNames from 'classnames/bind';
import PressReleaseDetailCard from 'components/news/pressReleaseDetail/PressReleaseDetailCard';
import { GetServerSidePropsContext } from 'next';
import axios, { AxiosResponse } from 'axios';
import { INewsItemDetail } from 'types/news';
import { FRONT_API_BASE_URL, RELEASE_ENV } from 'utils/config';
import OpengraphTag from 'components/OpengraphTag';
import { Empty } from 'antd';
import Head from 'next/head';
import convertHtmlToString from 'utils/convertHtmlToString';
import cutText from 'utils/cutText';
const cx = classNames.bind(styles);
interface IDetailProps {
    og_title: string;
    og_image: string;
    og_url: string;
    newsData: INewsItemDetail;
    error: unknown;
}
function detail({ og_url, og_title, og_image, error, newsData }: IDetailProps) {
    const renderer = () => {
        if (error) {
            return (<Empty description="데이터를 가져오는 도중 에러가 발생했습니다."/>);
        }
        if (newsData.data) {
            return (<>
          {RELEASE_ENV === 'production' && (<Head>
              <title>{newsData.data.attributes.title}</title>
              <meta name="description" content={cutText(convertHtmlToString(newsData.data.attributes.content))}/>
            </Head>)}
          <PressReleaseDetailCard newsData={newsData}/>
        </>);
        }
        return <Empty description="해당 보도자료가 존재하지 않아요."/>;
    };
    return (<>
      <OpengraphTag og_url={og_url} og_title={og_title} og_image={og_image} error={error}/>
      <div className={cx('container')}>{renderer()}</div>
    </>);
}
export default detail;
const getServerSideProps = async (context: GetServerSidePropsContext) => {
    const { locale, query } = context;
    const { id } = query;
    const route = locale === 'ko' ? 'news-kos' : 'news-ens';
    const default_og_title = locale === 'ko' ? '더핑크퐁컴퍼니 주식회사' : 'The Pinkfong Company';
    const default_og_url = locale === 'ko' ? FRONT_API_BASE_URL : `${FRONT_API_BASE_URL}/en`;
    const default_og_image = `${FRONT_API_BASE_URL}/images/thumbnail.png`;
    try {
        const newsData: AxiosResponse<INewsItemDetail> = await axios.get(`/api/${route}/${id}?populate=*`);
        return {
            props: {
                og_url: `${default_og_url}/news/pr/${id}`,
                og_title: newsData.data.data.attributes.title || default_og_title,
                og_image: newsData.data.data.attributes.thumbnail?.data?.attributes?.url ||
                    default_og_image,
                newsData: newsData.data,
            },
        };
    }
    catch (error) {
        return {
            props: {
                og_url: default_og_url,
                og_title: default_og_title,
                og_image: default_og_image,
                error,
            },
        };
    }
};

    async function __Next_Translate__getServerSideProps__19a29f8b278__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/news/pr/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__19a29f8b278__ as getServerSideProps }
  